import {
    TextField,
    Button,
    Box,
    FormHelperText,
    FormGroup,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import axiosInstance from "../../services/axios-instance";
import { EDIT_USER } from "../../services/endpoints";
import { useFormik } from "formik";
import * as Yup from "yup";
const StyledForm = styled("form")({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    margin: "0 5rem 2rem",
});

const validationSchema = Yup.object({
    password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters"),
    password_confirmation: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password")], "Passwords must match"),
});

interface ResetPasswordFormParams {
    userId: number;
    onClose: any;
    setAlertMessage: any;
    setOpenAlert: any;
}

function ResetPasswordForm({
    userId,
    onClose,
    setAlertMessage,
    setOpenAlert,
}: ResetPasswordFormParams) {
    const formik = useFormik({
        initialValues: {
            password: "",
            password_confirmation: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const { password, password_confirmation } = values;

            const requestBody = {
                password,
                password_confirmation,
            };

            const response = await axiosInstance.post(
                EDIT_USER(userId),
                requestBody
            );

            if (response.status === 200 || response.status === 201) {
                setAlertMessage("Password updated successfully");
                setOpenAlert(true);
                formik.resetForm();
            } else {
                console.error("Error submitting form:", response);
            }
        },
    });

    return (
        <>
            <Box maxWidth="500px" mx="auto">
                <StyledForm onSubmit={formik.handleSubmit} noValidate>
                    <FormGroup>
                        <TextField
                            name="password"
                            label="Password"
                            type="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.password &&
                                Boolean(formik.errors.password)
                            }
                            required
                        />
                        {formik.errors.password && formik.touched.password ? (
                            <FormHelperText>
                                {formik.errors.password}
                            </FormHelperText>
                        ) : null}
                    </FormGroup>
                    <FormGroup>
                        <TextField
                            name="password_confirmation"
                            label="Confirm Password"
                            type="password"
                            value={formik.values.password_confirmation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.password_confirmation &&
                                Boolean(formik.errors.password_confirmation)
                            }
                            required
                        />
                        {formik.errors.password_confirmation &&
                        formik.touched.password_confirmation ? (
                            <FormHelperText>
                                {formik.errors.password_confirmation}
                            </FormHelperText>
                        ) : null}
                    </FormGroup>
                    <Button
                        onClick={onClose}
                        type="submit"
                        variant="contained"
                        color="info"
                        disabled={formik.isSubmitting || !formik.isValid}
                    >
                        Submit
                    </Button>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                    >
                        Cancel
                    </Button>
                </StyledForm>
            </Box>
        </>
    );
}

export default ResetPasswordForm;
